import React from "react";
import { formatDateTime, productOrderStatusText } from "../../../utils";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

const OrderDetails = ({ orderDetail }) => {
  return (
    <div className="w-[50%]">
      <div className="flex justify-between">
        <TitlePage size="text-[14px]" title="주문내역" />
        <Link
          to="/order-management"
          className="cursor-pointer text-title-grey flex ml-2"
        >
          주문내역 관리
          <ChevronRightIcon className="-mt-[18px]" width={15} />
        </Link>
      </div>
      <div className="w-full h-[9.5rem] p-3 shadow-dashboard">
        {orderDetail.length > 0 ? (
          orderDetail.map((item, index) => (
            <div className="flex mb-2 space-x-2 items-center" key={index}>
              <p className="border border-black rounded-[4px] py-0.5 w-[4.5rem] text-center">
                {productOrderStatusText(item.status)}
              </p>
              <p>{formatDateTime(item.createdAt)}</p>
              <p>|</p>
              <p>{item.product.productGroup.productGroupCategory.name}</p>
              <p>|</p>
              <p>{item.product.name}</p>
              <p>|</p>
              <p>{item.qnt}개</p>
              <p>|</p>
              <p>{item.productOrderParent.hospital.name}</p>
            </div>
          ))
        ) : (
          <p className="text-center py-14 text-title-grey">
            주문된 내역이 없습니다.
          </p>
        )}
      </div>
    </div>
  );
};

export default OrderDetails;
